import b from 'b_';
import cx from 'classnames';
import { Link as LinkIcon } from 'education-icons';
import { Text } from 'platform-components';
import React from 'react';

import './external-lms-badge.scss';

enum THEME {
    COMPACT = 'compact',
    EXPANDED = 'expanded',
}

interface Props {
    mix?: string;
    theme?: THEME;
    textId: string;
}

const ExternalLmsBadge = ({ mix, theme, textId }: Props) => (
    <div className={cx(b('external-lms-badge', { theme }), mix)}>
        {theme === THEME.EXPANDED && <LinkIcon />}
        <Text id={textId} size={Text.SIZE.S} weight={Text.WEIGHT.L} />
    </div>
);

ExternalLmsBadge.defaultProps = {
    theme: THEME.COMPACT,
};

ExternalLmsBadge.THEME = THEME;

export default ExternalLmsBadge;
